// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var BigJs = require("big.js");
var FloatSafe = require("./FloatSafe.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

function format(options, number) {
  return number.toLocaleString("en-US", options);
}

function formatToDecimalPlace(decimalPrecision) {
  var partial_arg = {
    style: "decimal",
    minimumFractionDigits: decimalPrecision,
    maximumFractionDigits: decimalPrecision
  };
  return function (param) {
    return param.toLocaleString("en-US", partial_arg);
  };
}

var partial_arg = {
  currency: "USD",
  style: "currency"
};

function formatMoney(param) {
  return param.toLocaleString("en-US", partial_arg);
}

function roundTo(decimalPrecision) {
  return function (param) {
    return Relude_Globals.$great$great((function (param) {
                  return Relude_Globals.$great$great((function (prim) {
                                return new BigJs.Big(prim);
                              }), (function (param) {
                                return FloatSafe.round(decimalPrecision, param);
                              }), param);
                }), FloatSafe.toFloat, param);
  };
}

var roundToThousandths = roundTo(3);

var roundToHundreths = roundTo(2);

function centsToDollars(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(FloatSafe.fromInt, (function (__x) {
                                            return FloatSafe.div(__x, new BigJs.Big(100.0));
                                          }), param);
                            }), (function (param) {
                              return FloatSafe.round(2, param);
                            }), param);
              }), FloatSafe.toFloat, param);
}

var partial_arg$1 = new BigJs.Big(100.0);

function partial_arg$2(param) {
  return FloatSafe.mul(partial_arg$1, param);
}

function partial_arg$3(param) {
  return Relude_Globals.$great$great((function (prim) {
                return new BigJs.Big(prim);
              }), partial_arg$2, param);
}

function partial_arg$4(param) {
  return Relude_Globals.$great$great(partial_arg$3, FloatSafe.toFloat, param);
}

function dollarsToCents(param) {
  return Relude_Globals.$great$great(partial_arg$4, Relude_Float.roundAsInt, param);
}

function formatCentsToMoney(param) {
  return Relude_Globals.$great$great(centsToDollars, formatMoney, param);
}

var partial_arg$5 = formatToDecimalPlace(2);

function centsToString(param) {
  return Relude_Globals.$great$great(centsToDollars, partial_arg$5, param);
}

var partial_arg$6 = {
  style: "percent"
};

function formatPercent(param) {
  return param.toLocaleString("en-US", partial_arg$6);
}

function degreesToRadians(degrees) {
  return degrees * Math.PI / 180.0;
}

function kmToMiles(km) {
  return km * 0.621371;
}

var partial_arg$7 = Relude_Option.filterNot(function (param) {
      return Relude_Globals.$great$great(Relude_Float.fromInt, (function (prim) {
                    return isNaN(prim);
                  }), param);
    });

function hexStringToInt(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great((function (prim) {
                              return parseInt(prim, 16);
                            }), Relude_Option.pure, param);
              }), partial_arg$7, param);
}

function parseStringDollarsToCents(param) {
  return Relude_Globals.$great$great(Relude_Float.fromString, (function (param) {
                return Relude_Option.map(dollarsToCents, param);
              }), param);
}

function modulo(divisor, dividend) {
  return Relude_Int.modulo(dividend, divisor);
}

exports.format = format;
exports.formatToDecimalPlace = formatToDecimalPlace;
exports.formatMoney = formatMoney;
exports.roundTo = roundTo;
exports.roundToThousandths = roundToThousandths;
exports.roundToHundreths = roundToHundreths;
exports.centsToDollars = centsToDollars;
exports.dollarsToCents = dollarsToCents;
exports.formatCentsToMoney = formatCentsToMoney;
exports.centsToString = centsToString;
exports.formatPercent = formatPercent;
exports.degreesToRadians = degreesToRadians;
exports.kmToMiles = kmToMiles;
exports.hexStringToInt = hexStringToInt;
exports.parseStringDollarsToCents = parseStringDollarsToCents;
exports.modulo = modulo;
/* roundToThousandths Not a pure module */
